import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommHistoryComponent } from './comm-history.component';
import { MaterialModule } from '../../material/material.module';



@NgModule({
  declarations: [
    CommHistoryComponent
  ],
  imports: [
    CommonModule,
    MaterialModule
  ],
  exports:[
    CommHistoryComponent
  ]
})
export class CommHistoryModule { }
